let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9wm3Q")).then(() => parcelRequire('bCmcA'));